import { render, staticRenderFns } from "./EmisiaView.vue?vue&type=template&id=6096a474&scoped=true"
import script from "./EmisiaView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmisiaView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6096a474",
  null
  
)

export default component.exports